import { openLink } from '@tma.js/sdk-react'

const DOCUMENTATION_URL = 'https://telegra.ph/SwiftOK-07-31'

export const ContactManagerPage = () => {
  return (
    <div className="py-8 mx-auto max-w-2xl px-4">
      <div className="flex min-h-[70vh] flex-col items-center justify-center text-center">
        <h1 className="text-2xl font-semibold">Нет доступа</h1>
        <p className="mt-3 max-w-sm text-sm leading-6 text-[var(--app-muted)]">
          Свяжитесь с менеджером, чтобы подключиться к системе.
        </p>
        <a
          className="mt-8 inline-flex min-h-12 items-center justify-center rounded-full bg-[var(--app-accent)] px-5 py-3 text-sm font-semibold text-[var(--app-accent-text)] transition hover:opacity-90"
          href={import.meta.env.BUN_PUBLIC_MANAGER_LINK}
        >
          Написать менеджеру
        </a>
        <button
          className="mt-3 inline-flex min-h-12 items-center justify-center rounded-full px-5 py-3 text-sm font-semibold text-[var(--app-accent)] transition hover:opacity-75"
          onClick={() => openLink(DOCUMENTATION_URL, { tryInstantView: true })}
          type="button"
        >
          Инструкция по работе
        </button>
      </div>
    </div>
  )
}
